export const WIDTH_TO_LENGTH = {
  "100%": 12,
  "75%": 9,
  "50%": 6,
  "25%": 3,
  "33.33%": 4,
};

export const LENGTH_TO_WIDTH = {
  12: "100%",
  9: "75%",
  6: "50%",
  3: "25%",
  4: "33.33%",
};

export const LAYOUT_PRESETS = [
  {
    key: "full",
    label: "100",
    title: "Single column",
    widths: ["100%"],
  },
  {
    key: "half",
    label: "50/50",
    title: "Two equal columns",
    widths: ["50%", "50%"],
  },
  {
    key: "quarterThreeQuarter",
    label: "25/75",
    title: "Sidebar left",
    widths: ["25%", "75%"],
  },
  {
    key: "threeQuarterQuarter",
    label: "75/25",
    title: "Sidebar right",
    widths: ["75%", "25%"],
  },
  {
    key: "thirds",
    label: "33/33/33",
    title: "Three equal columns",
    widths: ["33.33%", "33.33%", "33.33%"],
  },
];

export const createEmptyRow = () => ({
  columns: [
    {
      width: "100%",
      widgets: [],
    },
  ],
});

export const getColumnLength = (width) => WIDTH_TO_LENGTH[width] || 12;

export const getWidthFromLength = (length) => LENGTH_TO_WIDTH[length] || "100%";

export const getAssignedWidgetIds = (rows = []) => rows.flatMap((row) => row.columns.flatMap((column) => column.widgets || []));

export const applyWidgetToRows = (rows = [], widgetId, targetRowIndex, targetColIndex) => rows.map((row, rowIndex) => ({
  ...row,
  columns: row.columns.map((column, colIndex) => {
    const widgets = (column.widgets || []).filter((id) => id !== widgetId);

    if (rowIndex === Number(targetRowIndex) && colIndex === Number(targetColIndex)) {
      return {
        ...column,
        widgets: [widgetId],
      };
    }

    return {
      ...column,
      widgets,
    };
  }),
}));

export const clearWidgetFromRows = (rows = [], rowIndex, colIndex) => rows.map((row, currentRowIndex) => {
  if (currentRowIndex !== Number(rowIndex)) {
    return row;
  }

  return {
    ...row,
    columns: row.columns.map((column, currentColIndex) => {
      if (currentColIndex !== Number(colIndex)) {
        return column;
      }

      return {
        ...column,
        widgets: [],
      };
    }),
  };
});

export const moveRowPosition = (rows = [], index, direction) => {
  if (direction === "up" && index <= 0) {
    return rows;
  }

  if (direction === "down" && index >= rows.length - 1) {
    return rows;
  }

  const nextRows = [...rows];
  const swapIndex = direction === "up" ? index - 1 : index + 1;
  const temp = nextRows[swapIndex];
  nextRows[swapIndex] = nextRows[index];
  nextRows[index] = temp;
  return nextRows;
};

export const applyLayoutToRow = (rows = [], rowIndex, colIndex, widths = []) => rows.map((row, currentRowIndex) => {
  if (currentRowIndex !== Number(rowIndex)) {
    return row;
  }

  const totalColumnsAfterSplit = row.columns.length - 1 + widths.length;
  if (totalColumnsAfterSplit > 4) {
    return row;
  }

  return {
    ...row,
    columns: row.columns.map((column, currentColIndex) => {
      if (currentColIndex !== Number(colIndex)) {
        return column;
      }

      return widths.map((width) => ({
        width,
        widgets: [],
      }));
    }).flat(),
  };
});
